export default __webpack_public_path__ + "static/media/btn-zeroback-stop-uk_en@3x.438e457c.png";